module.exports = __webpack_public_path__ + "static/img/clients-icon-24.b89eec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients-icon-24.png
// module id = 65
// module chunks = 0